// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PASSR_EMAIL_SEND_EXPLANATION = "Na email ti po\u0161leme in\u0161trukcie ako postupova\u0165.";
export const PASSR_EMAIL_TITLE = "Obnovenie hesla cez email";
export const PASSWORD_RESET_WE_SENT_TO_YOUR_EMAIL_INSTRUCTION_HOW_TO_RESET_PASSWORD = "Na emailov\u00fa adresu sme ti zaslali in\u0161trukcie ako si zada\u0165 nov\u00e9 heslo.";
export const WE_CANNOT_SEND_YOU_OLD_PASSWORD_BECAUSE_OF_SECURITY_REASON = "Star\u00e9 heslo ti z bezpe\u010dnostn\u00fdch d\u00f4vodov zasla\u0165 nem\u00f4\u017eeme.";
